
import './src/styles/_variables.scss';
export const onClientEntry = () => {
  document.documentElement.setAttribute("lang", "en");
};
